class UploadFeedUrlCtrl {

    constructor($scope, $uibModalInstance) {
        $scope.ok = this.ok.bind(this);
        $scope.cancel = this.cancel.bind(this);

        this.$uibModalInstance = $uibModalInstance;
    }

    ok(url) {
        this.$uibModalInstance.close(url);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module('cpm')
    .controller('UploadFeedUrlCtrl', ['$scope', '$uibModalInstance', UploadFeedUrlCtrl]);
